import { z } from 'zod';

import { guestClient } from '../clients.js';

const RecoQuerySchema = z.object({
  token: z.string(),
});
export const applyRecommendation = guestClient.mutation({
  url: 'recommendations/notifications/platforms/confirm' as const,
  method: 'POST',
  responseSchema: z.object({}),
  querySchema: RecoQuerySchema,
  processResponse(data) {
    return data;
  },
});

const RecommendationResponseSchema = z.object({
  clientName: z.string(),
  platformName: z.string(),
  recommendation: z.object({
    status: z.enum([
      'ACTIVE',
      'ACCEPTING',
      'REJECTED',
      'ACCEPTED',
      'ERROR',
      'EXPIRED',
    ]),
    taxonomy: z.object({
      channel: z.object({
        platform: z.object({
          name: z.string(),
          status: z.union([
            z.object({
              data: z.array(
                z.object({
                  objectId: z
                    .union([z.string(), z.number(), z.null()])
                    .optional(),
                  objectType: z.union([z.string(), z.null()]).optional(),
                  status: z.enum(['success', 'pending', 'error']).optional(),
                  details: z.union([z.string(), z.null()]).optional(),
                }),
              ),
            }),
            z.null(),
          ]),
        }),
      }),
    }),
    journeyName: z.string().optional(),
  }),
});
export const getRecommendation = guestClient.query({
  url: 'recommendations/notifications/platforms/landing' as const,
  method: 'GET',
  responseSchema: RecommendationResponseSchema,
  querySchema: RecoQuerySchema,
  processResponse(data) {
    const { recommendation, clientName, platformName } = data;
    return { ...recommendation, clientName, platformName };
  },
});

export const proveAction = guestClient.mutation({
  url: 'recommendations/notifications/platforms/actions' as const,
  method: 'POST',
  querySchema: RecoQuerySchema,
  requestSchema: z.object({
    action: z.string(),
  }),
  responseSchema: z.object({}),
  processResponse(data) {
    return data;
  },
});
